import { createIcon } from "@chakra-ui/icons";

// Source: https://fontawesome.com/icons/file-chart-column?s=solid

export default createIcon({
  displayName: "FileChartColumn",
  viewBox: "0 0 384 512",
  path: (
    <path
      d="M256 0v128h128L256 0zM224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM128 435.3C128 441.6 121.6 448 115.3 448h-38.5C70.38 448 64 441.6 64 435.3v-70.5C64 358.4 70.38 352 76.75 352h38.5C121.6 352 128 358.4 128 364.8V435.3zM224 435.3C224 441.6 217.6 448 211.3 448h-38.5C166.4 448 160 441.6 160 435.3v-198.5C160 230.4 166.4 224 172.8 224h38.5C217.6 224 224 230.4 224 236.8V435.3zM268.8 288h38.5C313.6 288 320 294.4 320 300.8v134.5C320 441.6 313.6 448 307.3 448h-38.5C262.4 448 256 441.6 256 435.3v-134.5C256 294.4 262.4 288 268.8 288z"
      fill="currentColor"
    />
  ),
});
